module.exports = __webpack_public_path__ + "static/media/roadmap.afe93674.png";